/* CUSTOM LED -- _customled-eu-withdrawal.js (owned, M10.1, 2026-10-16)
   Two-step EU withdrawal form for sections/customled-eu-withdrawal.liquid.
   Step 1 validates and shows a summary; step 2 "Confirm withdrawal" posts JSON to the Worker with a
   Cloudflare Turnstile token. Messages come from data-msg-* attributes (theme locale keys), with
   {order} / {email} / {date} filled in here. Turnstile loads only on this page. */
(function () {
  'use strict';
  var TS_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  function loadTurnstile(cb) {
    if (window.turnstile) return cb();
    var s = document.querySelector('script[data-cl-turnstile]');
    if (!s) {
      s = document.createElement('script');
      s.src = TS_SRC; s.async = true; s.defer = true; s.setAttribute('data-cl-turnstile', '');
      document.head.appendChild(s);
    }
    s.addEventListener('load', cb);
  }

  function fill(t, v) {
    return String(t || '').replace(/\{(order|email|date)\}/g, function (_, k) { return v[k] || ''; });
  }

  function init(form) {
    var d = form.dataset, lang = d.lang || 'en';
    var step1 = form.querySelector('[data-step="1"]'), step2 = form.querySelector('[data-step="2"]');
    var status = form.querySelector('.cl-wd-status'), tsBox = form.querySelector('.cl-wd-turnstile');
    var confirmBtn = form.querySelector('[data-action="confirm"]');
    var widgetId = null, busy = false;

    loadTurnstile(function () {
      widgetId = window.turnstile.render(tsBox, { sitekey: tsBox.dataset.sitekey, language: lang, appearance: 'interaction-only' });
    });

    function say(msg, linkUrl, linkText) {
      status.textContent = '';
      var p = document.createElement('p'); p.textContent = msg; status.appendChild(p);
      if (linkUrl) { var a = document.createElement('a'); a.href = linkUrl; a.textContent = linkText; a.className = 'link'; status.appendChild(a); }
    }
    function values() {
      return {
        order: form.elements.order.value.trim(), email: form.elements.email.value.trim(),
        name: form.elements.name.value.trim(), details: form.elements.details.value.trim()
      };
    }
    function show(n) {
      step1.hidden = n !== 1; step2.hidden = n !== 2;
      var h = (n === 2 ? step2.querySelector('h3') : form.elements.order); if (h) h.focus();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = values(), firstBad = null;
      ['order', 'email', 'name'].forEach(function (k) {
        var el = form.elements[k], bad = !v[k] || (k === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v[k])) || (k === 'order' && !/\d{4,}/.test(v[k]));
        el.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (bad && !firstBad) firstBad = el;
      });
      if (firstBad) { say(d.msgInvalid); firstBad.focus(); return; }
      status.textContent = '';
      step2.querySelector('[data-sum="order"]').textContent = v.order;
      step2.querySelector('[data-sum="email"]').textContent = v.email;
      step2.querySelector('[data-sum="name"]').textContent = v.name;
      step2.querySelector('[data-sum="details"]').textContent = v.details || d.msgWhole;
      show(2);
    });

    form.querySelector('[data-action="edit"]').addEventListener('click', function () { status.textContent = ''; show(1); });

    confirmBtn.addEventListener('click', function () {
      if (busy) return;
      var token = window.turnstile && widgetId !== null ? window.turnstile.getResponse(widgetId) : '';
      if (!token) { say(d.msgBot); show(1); return; }
      var v = values(); v.lang = lang; v.token = token;
      busy = true; confirmBtn.disabled = true; say(d.msgSending);
      fetch(d.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(v) })
        .then(function (r) { return r.json().catch(function () { return { status: 'error' }; }); })
        .then(function (j) {
          var date = j.date ? new Date(j.date).toLocaleString(lang) : '';
          var vars = { order: j.order || v.order, email: v.email, date: date };
          if (j.status === 'ok') { say(fill(d.msgSuccess, vars)); step2.hidden = true; step1.hidden = true; return; }
          if (j.status === 'already') { say(fill(d.msgAlready, vars)); step2.hidden = true; step1.hidden = true; return; }
          if (j.status === 'not_eu') { say(fill(d.msgNotEu, vars), d.policyUrl, d.msgPolicyLink); show(1); return; }
          var m = { nomatch: d.msgNomatch, bot: d.msgBot, rate: d.msgRate, invalid: d.msgInvalid }[j.status] || d.msgError;
          say(m); show(1);
        })
        .catch(function () { say(d.msgError); show(1); })
        .then(function () {
          busy = false; confirmBtn.disabled = false;
          if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId);   // tokens are single-use
        });
    });
  }

  function boot() { document.querySelectorAll('.cl-wd-form').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
